import {useEffect, useState} from 'react';
import {userService, courseService} from '@jobseeker/common-core/services';
import ListSimilarCourses from './ListSimilarCourses';
import {Box, Card, CardContent, Grid, Typography} from '@mui/material';
import {VersionVariants} from '@jobseeker/lotus/enums/variants';
import {Alert} from '@jobseeker/lotus/components';
import {Image} from '@jobseeker/lotus/components/Image';
import {HiristDone, Send} from '@jobseeker/lotus/assets/icons';
import useInterceptor from '@jobseeker/common-core/hooks/useInterceptor';
import {AdListCategory, SimilarCourseProps} from './type';
import ListTrendingCourses from './ListTrendindCourses';
import {cleanUrl} from '@jobseeker/lotus/utils';

const SimilarCourse = ({
  courseCatIds = '',
  enquiredCourseId = 0,
  setdialogOpen,
  refinv,
  reforg,
}: SimilarCourseProps) => {
  const [similarCourseEnquiryEnabled, setSimilarCourseEnquiryEnabled] =
    useState(false);
  const [showAlert, setShowAlert] = useState(true);
  const [similarCourses, setSimilarCourses] = useState<AdListCategory[]>([]);
  const [trendingCourses, setTrendingCourses] = useState<AdListCategory[]>([]);
  const [showSimilarCourses, setShowSimilarCourses] = useState(true);

  const removeSimilarCourses = () => {
    setdialogOpen && setdialogOpen(false);
    if (isAppIimjobs) {
      setShowSimilarCourses(false);
    }
  };

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const interceptor: any = useInterceptor();
  const isAppIimjobs = process.env.NEXT_PUBLIC_APP_NAME === 'iimjobs';

  const {ads} = interceptor;

  useEffect(() => {
    if (enquiredCourseId === 0) {
      return;
    }

    (async () => {
      try {
        const [userSettingsApiResponse, trendingCoursesApiResponse] =
          await Promise.all([
            userService.getUserSettings(),
            courseService.getRecommendedAndTrendingCourses({
              courseId: enquiredCourseId,
              params: {refinv, reforg},
            }),
          ]);

        setSimilarCourseEnquiryEnabled(
          userSettingsApiResponse.accountSettings?.similarCourseEnquiry === 1
        );

        setTrendingCourses(
          trendingCoursesApiResponse?.data?.adList?.trending?.slice(0, 4)
        );

        setSimilarCourses(
          trendingCoursesApiResponse?.data?.adList?.recommended?.slice(0, 2) ??
            []
        );
      } catch (error) {
        console.log({error});
      }
    })();
  }, [enquiredCourseId, courseCatIds, ads?.trendingCourses?.slot]);

  if (!showSimilarCourses) {
    return <></>;
  }

  return (
    <Box mb={isAppIimjobs ? 2 : 0}>
      {showAlert && isAppIimjobs && (
        <Alert
          onClose={() => setShowAlert(false)}
          variant={VersionVariants.VERSION_TWO}
          show={true}
          icon={
            <Box
              sx={{
                width: 32,
                minWidth: 32,
                height: 32,
                position: 'relative',
              }}
            >
              <Image
                alt="some image"
                src={Send}
                layout="fill"
                objectFit="contain"
                quality={100}
              />
            </Box>
          }
          sx={{
            '& .MuiAlert-icon': {
              mr: 1,
            },
            px: {xxs: 1, md: 1.5},
            mb: 2,
            alignItems: 'center',
          }}
        >
          <Typography
            fontSize={14}
            fontWeight={500}
            color="text.primary"
            lineHeight={'16px'}
          >
            Thank you for your interest. Your request has been successfully
            submitted. The institute shall contact you shortly.
          </Typography>
        </Alert>
      )}
      {!isAppIimjobs &&
        (!similarCourseEnquiryEnabled ? (
          <>
            <Box
              display="flex"
              sx={{
                ml: 4.5,
                mb: 3,
              }}
            >
              <Image
                src={HiristDone}
                alt="jp"
                width={26}
                height={26}
                style={{marginTop: 4}}
              />
              <Typography
                sx={{
                  fontSize: 15,
                  fontWeight: 400,
                  ml: 1,
                  mr: {xxs: 4.5, md: 0},
                }}
              >
                Thank you for your interest. Your request has been successfully
                submitted. The Institute shall contact you shortly.
              </Typography>
            </Box>
          </>
        ) : (
          <Box display="flex" sx={{px: 4.5, mb: 4}}>
            <Image
              src={HiristDone}
              alt="jp"
              width={26}
              height={26}
              style={{marginTop: 4}}
            />
            <Typography
              sx={{
                fontSize: 18,
                fontWeight: 400,
                ml: 1,

                maxWidth: 955,
              }}
            >
              Thank you for your interest. Your request has been successfully
              submitted. We have also enquired for below similar courses on your
              behalf. The institutes shall contact you shortly.
            </Typography>
          </Box>
        ))}
      {similarCourses?.length > 0 && (
        <ListSimilarCourses
          similarCourses={similarCourses}
          similarCourseEnquiryEnabled={similarCourseEnquiryEnabled}
          removeSimilarCourses={removeSimilarCourses}
        />
      )}
      {trendingCourses?.length > 0 &&
        (isAppIimjobs ? (
          <ListTrendingCourses trendingCourses={trendingCourses} />
        ) : (
          <Box sx={{backgroundColor: '#f2f5fa'}}>
            <Card
              variant={VersionVariants.VERSION_TWO}
              sx={{
                px: 0,
                py: 3,
                pb: 3,
                backgroundColor: '#f2f5fa',
              }}
            >
              <Typography fontSize={16} fontWeight={500} ml={4.5} mb={1}>
                Trending Courses
              </Typography>
              <Grid container spacing={2} paddingX={'36px'}>
                {trendingCourses?.map(
                  (course, index) =>
                    Boolean(course.metadata?.[0]?.['Image Url']) && (
                      <Grid item xs={12} sm={6} md={6} key={index}>
                        <a
                          href={
                            new URL(
                              `/course/${cleanUrl(course.metadata[0].Title)}-${
                                course.metadata[0].courseId
                              }?refinv=scc&reforg=sc`,
                              process.env.NEXT_PUBLIC_LOAD_CONFIG
                            ).href
                          }
                          style={{textDecoration: 'none'}}
                        >
                          <Card
                            sx={{
                              cursor: 'pointer',
                              display: 'flex',
                              alignItems: 'center',
                              padding: 2,
                              borderRadius: 3,
                              boxShadow: 1,
                              bgcolor: 'white',
                              height: {xxs: 'auto', md: 92},
                              width: '100%',
                              flexDirection: {xxs: 'column', md: 'row'},
                            }}
                          >
                            <Image
                              src={course.metadata[0]['Image Url']}
                              alt={'course'}
                              width={50}
                              height={50}
                              style={{
                                borderRadius: '8px',
                                border: '0.6px solid #7E7E7E33',
                              }}
                            />
                            <CardContent sx={{padding: '0 !important', ml: 1}}>
                              <Typography
                                sx={{
                                  fontSize: 16,
                                  fontWeight: 400,
                                  color: 'rgba(0,0,0,.7)',
                                  textAlign: {xxs: 'center', md: 'start'},
                                }}
                              >
                                {course.metadata[0].institute}
                              </Typography>
                              <Typography
                                sx={{
                                  fontSize: 14,
                                  fontWeight: 400,
                                  color: 'rgba(0,0,0,.7)',
                                  textAlign: {xxs: 'center', md: 'start'},
                                }}
                              >
                                {course.metadata[0].Title.slice(0, 47)}
                                {course.metadata[0].Title.length > 47
                                  ? '...'
                                  : ''}
                              </Typography>
                            </CardContent>
                          </Card>
                        </a>
                      </Grid>
                    )
                )}
              </Grid>
            </Card>
          </Box>
        ))}
    </Box>
  );
};

export default SimilarCourse;
